let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("15N8O")).then(() => parcelRequire('cN7t9'));